import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IAddNoteInterventionRequest from 'services/httpClient/requests/intervention/IAddNoteInterventionRequest';
import IAddNoteInterventionResponse from 'services/httpClient/responses/intervention/IAddNoteInterventionResponse';

import { interventionActions } from '../index';
import { IAddNoteInterventionRequestAction } from '../reducers/addNote/request';

function* addNote(action: PayloadAction<IAddNoteInterventionRequestAction>) {
  try {
    const body: IAddNoteInterventionRequest = {
      text: action.payload.data.text,
    };

    const response: AxiosResponse<IAddNoteInterventionResponse> = yield call(
      rikHttpClient.post,
      `interventions/${action.payload.data.interventionId}/add_note`,
      body,
    );

    yield put(interventionActions.addNoteSuccess({ note: response.data }));
    action.payload.functions.close();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.addNoteFailure());
  }
}

export default addNote;
